// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tags_tag__1TnRy","easy":"Tags_easy__1qfha","medium":"Tags_medium__HJ8Pr","hard":"Tags_hard__2xZML"};